import React, { useEffect, useState } from 'react';
import InvitesList from '../../components/Admin/Invites/Invites';
import Loader from '../../components/Loader/Loader';
import { withFirebase } from '../../components/Firebase';
import { useOrganizationStore } from '../../store/organization.store';

const Invites = ({ firebase }) => {
  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(true);
  const currentOrgId = useOrganizationStore((state) => state.currentOrgId);
  const currentOrgName = useOrganizationStore((state) => state.currentOrgName);

  useEffect(() => {
    if (!currentOrgId) {
      setLoading(false);
      return;
    }

    const loadInvites = async () => {
      try {
        setLoading(true);
        const orgInvites = await firebase.getOrgInvites(currentOrgId);
        setInvites(orgInvites);
      } catch (err) {
        console.error('Error loading invites:', err);
      } finally {
        setLoading(false);
      }
    };

    loadInvites();
  }, [firebase, currentOrgId]);

  const handleRefresh = async () => {
    if (!currentOrgId) return;
    setLoading(true);
    try {
      const orgInvites = await firebase.getOrgInvites(currentOrgId);
      setInvites(orgInvites);
    } catch (err) {
      console.error('Error refreshing invites:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="pt-3">
        {loading ? (
          <Loader />
        ) : (
          <InvitesList
            invites={invites}
            firebase={firebase}
            orgId={currentOrgId}
            orgName={currentOrgName}
            onRefresh={handleRefresh}
          />
        )}
      </div>
    </>
  );
};

export default withFirebase(Invites);
